const homeProjects = [

	/**-------------
	 * EASY EMAIL
	----------------*/
	{
		id: 1,
		title: 'Easy Email',
		category: 'Aplicación Web',
		img: require('@/assets/images/projects/email.png')
	},

	/**===========
	 * NOVATECH
	==============*/
	{
		id: 2,
		title: 'Novatech',
		category: 'Página Web',
		img: require('@/assets/images/projects/novatech.png')
	},

	/**-------------------
	 * MAPS APPLICATION
	----------------------*/
	{
		id: 3,
		title: 'Aplicación de Mapas',
		category: 'Aplicación Web',
		img: require('@/assets/images/projects/maps.png')
	},

];

export default homeProjects;
